import profile from "../noah-bio-profile.jpg";

export const HomeContent = () => {
  return (
    <div className="relative h-dvh flex items-center justify-center p-8 bg-black">
      <div className="relative container mx-auto flex flex-col items-center gap-12 max-w-lg">
        <img
          src={profile}
          alt="Noah in his studio with his musical instruments in the background"
          className="mx-auto size-64 rounded-full shadow-md"
        />

        <div className="text-sand flex flex-col items-center gap-10 text-center">
          <div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif drop-shadow-sm">
              Noah Fernandes
            </h1>
            <div className="mx-auto mt-2 mb-1 h-px w-56 bg-sand"></div>
            <p className="text-lg sm:text-xl md:text-xl">
              one man with many identities
            </p>
            <p className="text-lg sm:text-xl md:text-xl mt-8">
              Musician / Producer / Sound Healer / Software Engineer
            </p>
            <p className="text-lg sm:text-xl md:text-xl mt-2">
              Based in Amsterdam, Netherlands.
            </p>
          </div>

          <p className="text-sand text-lg">
            <a href="mailto:hello@noahfernandes.com" className="underline">
              hello@noahfernandes.com
            </a>
          </p>

          <p className="text-md mt-4">
            This site is under construction, but feel free to reach out if you
            want to collaborate or just say hi!
          </p>
        </div>
      </div>
    </div>
  );
};
